var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "today_table" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "detail_box" }, [
      _c(
        "a",
        { staticClass: "link_detail", attrs: { href: _vm.tableLinkUrl } },
        [
          _c("div", { staticClass: "thumb_table" }, [
            _vm.imageUrl
              ? _c("img", {
                  staticClass: "thumb_img",
                  attrs: { src: _vm.tableImageUrl, alt: "사용자 이미지" },
                })
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cont_table" }, [
            _c("strong", { staticClass: "tit_table" }, [
              _c("span", { staticClass: "txt_tit" }, [
                _vm._v(_vm._s(_vm.name)),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "txt_num" }, [
                _vm._v("손님 " + _vm._s(_vm.favoriteCount.toLocaleString())),
              ]),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "desc_table" }, [
              _vm._v(_vm._s(_vm.description)),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "relate_detail" }, [
        _c("strong", { staticClass: "screen_out" }, [
          _vm._v("월간 인기글 리스트"),
        ]),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "list_relate" },
          _vm._l(
            _vm.posts,
            function ({ tableId, postId, title, commentCount }) {
              return _c("li", { key: postId }, [
                _c(
                  "a",
                  {
                    staticClass: "link_item",
                    attrs: {
                      href: `//table-m.cafe.daum.net/p/${tableId}/${postId}`,
                    },
                  },
                  [
                    _c("strong", { staticClass: "tit_item" }, [
                      _vm._v(_vm._s(title)),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "txt_cmt" }, [
                      _vm._v(
                        "댓글 " + _vm._s(_vm.formatCommentCount(commentCount))
                      ),
                    ]),
                  ]
                ),
              ])
            }
          ),
          0
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("a", { staticClass: "link_more", attrs: { href: _vm.tableLinkUrl } }, [
      _c("em", { staticClass: "emph_txt" }, [
        _vm._v(_vm._s(_vm.postCount.toLocaleString()) + "개의"),
      ]),
      _vm._v(" 이야기 더보기\n\t"),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "tit_box" }, [
      _c(
        "a",
        { staticClass: "link_tit", attrs: { href: "//table-m.cafe.daum.net" } },
        [
          _c("h3", { staticClass: "tit_table" }, [
            _vm._v("카페 안의 또 다른 놀이터!"),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "ico_arrow" }),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }